var _circle, _circle2, _rect, _circle3, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountProfile = function SvgAccountProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#4376B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Account_Profile_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Account_Profile_svg__a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 37.5,
    y: -3,
    width: 33.75,
    height: 36.75,
    rx: 2,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 4.125,
    cy: 47.625,
    r: 14.625,
    stroke: "#000",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.314 33.542c6.127 0 11.094-4.99 11.094-11.146 0-6.156-4.967-11.146-11.094-11.146s-11.093 4.99-11.093 11.146c0 6.155 4.966 11.146 11.093 11.146Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.814 32.042c6.127 0 11.094-4.99 11.094-11.146 0-6.156-4.967-11.146-11.094-11.146s-11.093 4.99-11.093 11.146c0 6.155 4.966 11.146 11.093 11.146Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.021 38.343a20.777 20.777 0 0 0-13.16 7.072 21.145 21.145 0 0 0-5.108 14.137v53.636c0 1.806.71 3.539 1.977 4.817A6.72 6.72 0 0 0 19.502 120a6.72 6.72 0 0 0 4.773-1.995 6.847 6.847 0 0 0 1.977-4.817v-6.813c0-1.806.71-3.539 1.977-4.817A6.72 6.72 0 0 1 33 99.563a6.72 6.72 0 0 1 4.773 1.995 6.847 6.847 0 0 1 1.977 4.817v6.813c0 1.806.711 3.539 1.977 4.817A6.72 6.72 0 0 0 46.5 120a6.72 6.72 0 0 0 4.772-1.995 6.847 6.847 0 0 0 1.977-4.817V58.689a20.643 20.643 0 0 0-1.748-8.274 20.475 20.475 0 0 0-4.913-6.855 20.25 20.25 0 0 0-7.238-4.267 20.117 20.117 0 0 0-8.33-.95Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.021 35.343a20.777 20.777 0 0 0-13.16 7.072 21.145 21.145 0 0 0-5.108 14.137v53.636c0 1.806.71 3.539 1.977 4.817A6.72 6.72 0 0 0 16.502 117a6.72 6.72 0 0 0 4.773-1.995 6.847 6.847 0 0 0 1.977-4.817v-6.813c0-1.806.71-3.54 1.977-4.817A6.718 6.718 0 0 1 30 96.563c1.79 0 3.507.718 4.773 1.995a6.845 6.845 0 0 1 1.977 4.817v6.813c0 1.806.711 3.539 1.977 4.817A6.72 6.72 0 0 0 43.5 117a6.72 6.72 0 0 0 4.772-1.995 6.847 6.847 0 0 0 1.977-4.817V55.689a20.643 20.643 0 0 0-1.748-8.274 20.475 20.475 0 0 0-4.913-6.855 20.25 20.25 0 0 0-7.238-4.267 20.117 20.117 0 0 0-8.33-.95Z",
    fill: "#CAD9ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Account_Profile_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 35,
    width: 42,
    height: 82
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.021 35.343a20.777 20.777 0 0 0-13.16 7.072 21.145 21.145 0 0 0-5.108 14.137v53.636c0 1.806.71 3.539 1.977 4.817A6.72 6.72 0 0 0 16.502 117a6.72 6.72 0 0 0 4.773-1.995 6.847 6.847 0 0 0 1.977-4.817v-6.813c0-1.806.71-3.54 1.977-4.817A6.718 6.718 0 0 1 30 96.563c1.79 0 3.507.718 4.773 1.995a6.845 6.845 0 0 1 1.977 4.817v6.813c0 1.806.711 3.539 1.977 4.817A6.72 6.72 0 0 0 43.5 117a6.72 6.72 0 0 0 4.772-1.995 6.847 6.847 0 0 0 1.977-4.817V55.689a20.643 20.643 0 0 0-1.748-8.274 20.475 20.475 0 0 0-4.913-6.855 20.25 20.25 0 0 0-7.238-4.267 20.117 20.117 0 0 0-8.33-.95Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Account_Profile_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.75 34.867a13.709 13.709 0 0 0 4.855 4.685A12.948 12.948 0 0 0 30 41.25c2.233 0 4.43-.584 6.395-1.698a13.709 13.709 0 0 0 4.855-4.685 16.013 16.013 0 0 0-5.926-3.895 15.403 15.403 0 0 0-6.941-.893c-3.648.357-7.06 2.053-9.633 4.788Z",
    fill: "#000"
  })))));
};
export default SvgAccountProfile;